import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading text-foreground-50">
                白云视频
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              汇聚97视频、丝瓜视频同类高清影视资源，最新电影热播电视剧综艺节目独家剧集免费在线观看。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">影视分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">更多分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">关于我们</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <a
                  href="https://www.baiyunvideo.com/sitemap.xml"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  rel="nofollow"
                >
                  网站地图
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-700/30 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 白云视频 baiyunvideo.com 版权所有
          </p>
          <p className="text-xs text-foreground-500">
            本站所有资源均来自互联网，仅供学习和交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}